import axios from 'axios';

export default class AxiosService {
  constructor(baseURL, timeout, paramHeaders) {
    const headers = paramHeaders;

    // Set default headers if not provided
    if (!headers['Content-type']) { headers['Content-type'] = 'application/json'; } // eslint-disable-line dot-notation
    if (!headers['Accept']) { headers['Accept'] = 'application/json'; } // eslint-disable-line dot-notation

    this.instance = axios.create({
      baseURL,
      timeout,
      headers,
    });
  }

  // Get existing data API request
  get(apiURL, params) {
    return this.instance.get(apiURL, params);
  }

  // Post new data API request
  post(apiURL, params) {
    return this.instance.post(apiURL, params);
  }

  // Delete current data API request
  delete(apiURL, params) {
    return this.instance.delete(apiURL, params);
  }

  // Update current data API request
  put(apiURL, params) {
    return this.instance.put(apiURL, params);
  }

  // Patch a current data set API request
  patch(apiURL, params) {
    return this.instance.patch(apiURL, params);
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/axios-service.js
 **/